import { GENERATED_ARTIFACT_DEMO_HTML } from './generatedArtifactDemoHtmlPayload.js'

export function buildDemoPayloadForKind(kind, title) {
  if (kind === 'spreadsheet') {
    return {
      columns: ['Category', 'Owner', 'Budget', 'Status'],
      rows: [
        { Category: 'Research', Owner: 'Avery', Budget: '$12,000', Status: 'Planned' },
        { Category: 'Design', Owner: 'Mina', Budget: '$18,500', Status: 'In progress' },
        { Category: 'Launch', Owner: 'Sam', Budget: '$9,750', Status: 'Ready' },
      ],
    }
  }
  if (kind === 'html') return { html: GENERATED_ARTIFACT_DEMO_HTML }
  return {
    sections: [
      { type: 'heading', content: title },
      { type: 'paragraph', content: 'This generated document starts with a concise executive summary.' },
      { type: 'heading', content: 'Objectives' },
      { type: 'paragraph', content: 'Define scope, success criteria, stakeholders, and next actions.' },
      { type: 'heading', content: 'Next Steps' },
      { type: 'paragraph', content: 'Review the draft, refine details, and assign owners.' },
    ],
  }
}
